/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobBatchResponse {
    getFixupPrototypeFunction() { return BackgroundJobBatchResponse.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobBatchResponse>): BackgroundJobBatchResponse {
        let obj = Object.assign(new BackgroundJobBatchResponse(), model);
        BackgroundJobBatchResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobBatchResponse>): BackgroundJobBatchResponse {
        if (!model) return null;
        return BackgroundJobBatchResponse.newInstance(<BackgroundJobBatchResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobBatchResponse) {
        if (!obj) return;

        models.BackgroundJobBatchResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobBatchResponse): boolean {
        Object.setPrototypeOf(obj, BackgroundJobBatchResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let key in this.results) {
                let val = this.results[key];
                if (val) {
                    models.BackgroundJob.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Map from identifier to response model
     */
    results: { [key: string]: models.BackgroundJob; };

}
